import { createFileRoute } from "@tanstack/react-router";
import { SetupPassword } from "@/features/auth/components/SetupPassword";

export const Route = createFileRoute("/auth/setup-password")({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      token: (search.token as string) || "",
    };
  },
  component: SetupPassword,
});
